import Vue from "vue"
import { config as appConfig, config } from "/app.config"

Vue.mixin({
  data: function () {
    return {
      appConfig: config,
    }
  },

  computed: {
    isAutomationEnabled() {
      return appConfig.automation
    },
    isZeno() {
      return appConfig.isZeno
    },
    isAiir() {
      return appConfig.appName === "Aiir"
    },
    isNistar() {
      return appConfig.appName === "NistarAds"
    },
    isSurferNetwork() {
      return appConfig.appName === "SurferNETWORK"
    },
    isWhiteLabel() {
      return this.isAiir || this.isNistar || this.isSurferNetwork
    },
    hasSubscriptions() {
      return appConfig.hasSubscriptions
    },
    stationNameRules() {
      if (this.isAiir) return "required|max:255"
      return `required|station_name_min:${appConfig.stationNameMinLength}|max:255|station_name`
    },
    logoValidationRules() {
      return {
        required: true,
        ext: ["jpg", "jpeg", "png", "webp"],
        size: 1000,
        aspectSquare: true,
        dimensions: ["1400x1400", "3000x3000"],
      }
    },
  },
})
